const breakpoints = ["400px", "720px", "900px", "1152px", "1460px"];
const breakpointsMax = ["399px", "719px", "899px", "1151px", "1459px"];
const labels = ["xs", "sm", "md", "lg", "xl"];

export { breakpoints, breakpointsMax, labels };
